import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=539bd0b2&scoped=true&"
import script from "./user-select.vue?vue&type=script&lang=js&"
export * from "./user-select.vue?vue&type=script&lang=js&"
import style0 from "./user-select.vue?vue&type=style&index=0&id=539bd0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539bd0b2",
  null
  
)

export default component.exports